import StubPage from "./StubPage";
import { Heart, Users, Award, Sparkles } from "lucide-react";
export default function Women() {
  return <StubPage eyebrow="Women in Karate" title="30% Reserved Participation Initiative"
    subtitle="NKF Bharat is committed to gender parity — with dedicated tracks for women athletes, coaches, referees and officials."
    sections={[
      { icon: Heart, title: "Reserved Categories", body: "Every NKF Bharat national event features dedicated women categories with equal prize money and ranking points." },
      { icon: Users, title: "Women Coaches", body: "Targeted scholarship for women coach certification, with mentorship from senior international female coaches." },
      { icon: Award, title: "Women Referees", body: "Fast-track referee certification programme with regional and national assignment guarantees." },
      { icon: Sparkles, title: "Leadership Track", body: "Women in Federation Governance — dedicated seats in district, state and national executive bodies." },
    ]}
  />;
}
